export default __webpack_public_path__ + "static/header.augenaerztin.uebersicht-2a28d7d5257b7c19db4f5111aca9f4c1.png";